import type { WaterBillTarget } from "../../models/WaterBilling";
import { TableCell, TableHead, TableRow } from "@mui/material";

const HEAD_GROUP_SX = {
	backgroundColor: "#fff",
	borderRight: "1px solid",
	borderColor: "divider",
	color: "text.secondary",
	fontSize: 11,
	fontWeight: 600,
	lineHeight: 2,
	position: "sticky",
	px: 0.5,
	py: 0,
	textAlign: "center",
	top: 0,
	verticalAlign: "middle",
	whiteSpace: "nowrap",
	zIndex: 2,
} as const;

const HEAD_SPANNING_SX = {
	...HEAD_GROUP_SX,
	borderBottom: "1px solid #e4e4e5",
	whiteSpace: "normal",
	textWrap: "balance",
	lineHeight: 1.25,
	verticalAlign: "middle",
} as const;

const HEAD_SUB_SX = {
	...HEAD_GROUP_SX,
	borderBottom: "1px solid #e4e4e5",
	top: 22,
} as const;

export const CustomTableHeaders = ({
	targets,
}: {
	targets: WaterBillTarget[];
}) => (
	<TableHead>
		<TableRow>
			<TableCell rowSpan={2} sx={HEAD_SPANNING_SX}>
				Meter
			</TableCell>
			<TableCell rowSpan={2} sx={HEAD_SPANNING_SX}>
				Meter Size
			</TableCell>
			<TableCell colSpan={4} sx={HEAD_GROUP_SX}>
				Service Period
			</TableCell>
			<TableCell colSpan={2} sx={HEAD_GROUP_SX}>
				Gallons Per Meter
			</TableCell>
			<TableCell colSpan={2} sx={HEAD_GROUP_SX}>
				Total Gallons
			</TableCell>
			<TableCell rowSpan={2} sx={HEAD_SPANNING_SX}>
				Balance Forward
			</TableCell>
			<TableCell rowSpan={2} sx={HEAD_SPANNING_SX}>
				Current Bill
			</TableCell>
			<TableCell rowSpan={2} sx={HEAD_SPANNING_SX}>
				Check #
			</TableCell>
			<TableCell rowSpan={2} sx={HEAD_SPANNING_SX}>
				Pay Date
			</TableCell>
			{targets.length > 0 && (
				<>
					<TableCell colSpan={targets.length} sx={HEAD_GROUP_SX}>
						% to Mill
					</TableCell>
					<TableCell colSpan={targets.length} sx={HEAD_GROUP_SX}>
						Gallon Breakdown
					</TableCell>
					<TableCell colSpan={targets.length} sx={HEAD_GROUP_SX}>
						Cost Breakdown
					</TableCell>
				</>
			)}
			<TableCell rowSpan={2} sx={HEAD_SPANNING_SX} />
		</TableRow>
		<TableRow>
			<TableCell sx={HEAD_SUB_SX}>Start Date</TableCell>
			<TableCell sx={HEAD_SUB_SX}>Act. / Estim.</TableCell>
			<TableCell sx={HEAD_SUB_SX}>End Date</TableCell>
			<TableCell sx={HEAD_SUB_SX}>Act. / Estim.</TableCell>
			<TableCell sx={HEAD_SUB_SX}>Actual</TableCell>
			<TableCell sx={HEAD_SUB_SX}>Tracked</TableCell>
			<TableCell sx={HEAD_SUB_SX}>Actual</TableCell>
			<TableCell sx={HEAD_SUB_SX}>Tracked</TableCell>
			{targets.map((allocation) => (
				<TableCell key={`pct-${allocation.TargetId}`} sx={HEAD_SUB_SX}>
					{allocation.TargetName}
				</TableCell>
			))}
			{targets.map((allocation) => (
				<TableCell key={`brk-${allocation.TargetId}`} sx={HEAD_SUB_SX}>
					{allocation.TargetName}
				</TableCell>
			))}
			{targets.map((allocation) => (
				<TableCell key={`cost-${allocation.TargetId}`} sx={HEAD_SUB_SX}>
					{allocation.TargetName}
				</TableCell>
			))}
		</TableRow>
	</TableHead>
);
